(function () {
  'use strict';

  var MONTHS_ES = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  var SLOT_LABELS = {
    morning: 'Mañana',
    afternoon: 'Tarde',
    evening: 'Noche'
  };

  function init() {
    var popups = document.querySelectorAll('.ipta-booking-popup');
    if (popups.length === 0) return;

    popups.forEach(function (popup) {
      initPopup(popup);
    });

    interceptAppointoTriggers(popups);
  }

  function initPopup(popup) {
    var state = {
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      selectedDate: null,
      selectedSlot: null,
      serviceFromTrigger: null
    };

    var overlay = popup.querySelector('.ipta-booking-popup__overlay');
    var monthYearEl = popup.querySelector('[data-ipta-booking-month-year]');
    var daysGrid = popup.querySelector('[data-ipta-booking-days]');
    var prevBtn = popup.querySelector('[data-ipta-booking-prev]');
    var nextBtn = popup.querySelector('[data-ipta-booking-next]');
    var closeBtns = popup.querySelectorAll('[data-ipta-booking-close]');
    var submitBtn = popup.querySelector('[data-ipta-booking-submit]');
    var errorEl = popup.querySelector('[data-ipta-booking-error]');
    var slotBtns = popup.querySelectorAll('[data-ipta-booking-timeslot]');
    var nameInput = popup.querySelector('[data-ipta-booking-name]');
    var dniInput = popup.querySelector('[data-ipta-booking-dni]');
    var serviceInput = popup.querySelector('[data-ipta-booking-service]');
    var serviceSelect = popup.querySelector('[data-ipta-booking-service-select]');
    var serviceField = popup.querySelector('[data-ipta-booking-service-field]');

    // Leer configuración de días
    var availableDaysStr = popup.dataset.availableDays || '1,2,3,4,5';
    var availableDays = availableDaysStr.split(',').map(function(d) { return parseInt(d.trim()); });

    var blockedDatesStr = popup.dataset.blockedDates || '';
    var blockedDates = blockedDatesStr.split('\n').map(function(d) { return d.trim(); }).filter(function(d) { return d.length > 0; });

    var config = {
      whatsappNumber: popup.dataset.whatsappNumber || '',
      messageTemplate: popup.dataset.messageTemplate || '',
      productTitle: popup.dataset.productTitle || '',
      validationMessage: popup.dataset.validationMessage || 'Por favor completa todos los campos.',
      successMessage: popup.dataset.successMessage || 'Redirigiendo a WhatsApp...'
    };

    function isDateDisabled(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      if (date < today) return true;

      var dayOfWeek = date.getDay();
      if (availableDays.indexOf(dayOfWeek) === -1) return true;

      var dateStr = date.getFullYear() + '-' + String(date.getMonth() + 1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0');
      if (blockedDates.indexOf(dateStr) !== -1) return true;

      return false;
    }

    function renderCalendar() {
      if (!monthYearEl || !daysGrid) return;

      monthYearEl.textContent = MONTHS_ES[state.currentMonth] + ' ' + state.currentYear;

      var firstDay = new Date(state.currentYear, state.currentMonth, 1);
      var lastDay = new Date(state.currentYear, state.currentMonth + 1, 0);
      var totalDays = lastDay.getDate();
      var startDayOfWeek = firstDay.getDay();
      startDayOfWeek = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;

      var today = new Date();
      today.setHours(0, 0, 0, 0);

      daysGrid.innerHTML = '';

      for (var i = 0; i < startDayOfWeek; i++) {
        var emptyCell = document.createElement('span');
        emptyCell.className = 'ipta-booking-popup__day ipta-booking-popup__day--empty';
        daysGrid.appendChild(emptyCell);
      }

      for (var day = 1; day <= totalDays; day++) {
        var date = new Date(state.currentYear, state.currentMonth, day);
        date.setHours(0, 0, 0, 0);

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ipta-booking-popup__day';
        btn.textContent = day;

        if (isDateDisabled(date)) {
          btn.classList.add('ipta-booking-popup__day--disabled');
        }

        if (date.getTime() === today.getTime()) {
          btn.classList.add('ipta-booking-popup__day--today');
        }

        if (state.selectedDate && date.getTime() === state.selectedDate.getTime()) {
          btn.classList.add('ipta-booking-popup__day--selected');
        }

        btn.addEventListener('click', (function(d, b) {
          return function () {
            if (isDateDisabled(d)) return;
            state.selectedDate = d;
            hideError();
            renderCalendar();
          };
        })(date, btn));

        daysGrid.appendChild(btn);
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        state.currentMonth--;
        if (state.currentMonth < 0) {
          state.currentMonth = 11;
          state.currentYear--;
        }
        renderCalendar();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        state.currentMonth++;
        if (state.currentMonth > 11) {
          state.currentMonth = 0;
          state.currentYear++;
        }
        renderCalendar();
      });
    }

    slotBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slot = btn.dataset.iptaBookingTimeslot;
        state.selectedSlot = slot;
        slotBtns.forEach(function (b) {
          b.classList.remove('ipta-booking-popup__timeslot-card--selected');
        });
        btn.classList.add('ipta-booking-popup__timeslot-card--selected');
        hideError();
      });
    });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.classList.add('ipta-booking-popup__message--error');
      errorEl.classList.remove('ipta-booking-popup__message--success');
      errorEl.hidden = false;
    }

    function hideError() {
      if (!errorEl) return;
      errorEl.hidden = true;
    }

    function formatDate(date) {
      var d = date.getDate();
      var m = MONTHS_ES[date.getMonth()].toLowerCase();
      var y = date.getFullYear();
      return d + ' de ' + m + ' de ' + y;
    }

    function getServiceValue() {
      if (serviceInput && serviceInput.value.trim()) {
        return serviceInput.value.trim();
      }
      if (serviceSelect && serviceSelect.value.trim()) {
        return serviceSelect.value.trim();
      }
      return config.productTitle || 'servicio';
    }

    function updateServiceVisibility() {
      if (!serviceField) return;
      var hasHiddenService = serviceInput && serviceInput.value.trim() !== '';
      if (hasHiddenService) {
        serviceField.classList.add('ipta-booking-popup__field--service--hidden');
      } else {
        serviceField.classList.remove('ipta-booking-popup__field--service--hidden');
      }
    }

    function setServiceFromTrigger(service) {
      state.serviceFromTrigger = service || null;
      if (serviceInput) {
        serviceInput.value = service || '';
      }
      updateServiceVisibility();
    }

    function buildWhatsAppUrl() {
      var nombre = nameInput ? nameInput.value.trim() : '';
      var dni = dniInput ? dniInput.value.trim() : '';
      var servicio = getServiceValue();

      if (!servicio) {
        showError('Por favor selecciona un servicio.');
        return null;
      }
      if (!nombre) {
        showError('Por favor ingresa tu nombre.');
        return null;
      }
      if (!dni || dni.length < 8) {
        showError('Por favor ingresa un DNI válido (8 dígitos).');
        return null;
      }
      if (!state.selectedDate) {
        showError('Por favor selecciona una fecha.');
        return null;
      }
      if (!state.selectedSlot) {
        showError('Por favor selecciona un turno.');
        return null;
      }

      var fecha = formatDate(state.selectedDate);
      var turno = SLOT_LABELS[state.selectedSlot] || state.selectedSlot;

      var message = config.messageTemplate
        .replace(/\{nombre\}/g, nombre)
        .replace(/\{dni\}/g, dni)
        .replace(/\{servicio\}/g, servicio)
        .replace(/\{fecha\}/g, fecha)
        .replace(/\{turno\}/g, turno);

      return 'https://wa.me/' + config.whatsappNumber + '?text=' + encodeURIComponent(message);
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var url = buildWhatsAppUrl();
        if (!url) return;

        if (errorEl) {
          errorEl.textContent = config.successMessage;
          errorEl.classList.add('ipta-booking-popup__message--success');
          errorEl.classList.remove('ipta-booking-popup__message--error');
          errorEl.hidden = false;
        }

        setTimeout(function () {
          window.open(url, '_blank', 'noopener,noreferrer');
          closePopup();
        }, 400);
      });
    }

    function openPopup() {
      popup.classList.add('ipta-booking-popup--open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ipta-booking-popup--scroll-locked');

      state.currentMonth = new Date().getMonth();
      state.currentYear = new Date().getFullYear();
      state.selectedDate = null;
      state.selectedSlot = null;
      hideError();
      slotBtns.forEach(function (b) {
        b.classList.remove('ipta-booking-popup__timeslot-card--selected');
      });
      if (nameInput) nameInput.value = '';
      if (dniInput) dniInput.value = '';
      updateServiceVisibility();
      renderCalendar();

      var closeBtn = popup.querySelector('.ipta-booking-popup__close');
      if (closeBtn) {
        setTimeout(function () { closeBtn.focus(); }, 100);
      }
    }

    function closePopup() {
      popup.classList.remove('ipta-booking-popup--open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ipta-booking-popup--scroll-locked');
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', closePopup);
    });

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) closePopup();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('ipta-booking-popup--open')) {
        closePopup();
        var trigger = document.querySelector('.ipta-booking-trigger');
        if (trigger) trigger.focus();
      }
    });

    popup.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusable = popup.querySelectorAll(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    popup._iptaBookingOpen = openPopup;
    popup._iptaBookingSetService = setServiceFromTrigger;
    renderCalendar();
  }

  function interceptAppointoTriggers(popups) {
    if (popups.length === 0) return;

    var activePopup = null;
    popups.forEach(function (p) {
      if (!activePopup) activePopup = p;
    });

    if (!activePopup || !activePopup._iptaBookingOpen) return;

    document.querySelectorAll('.ipta-booking-trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var service = trigger.dataset.iptaBookingService || '';
        if (activePopup._iptaBookingSetService) {
          activePopup._iptaBookingSetService(service);
        }

        activePopup._iptaBookingOpen();

        if (!service) {
          var select = activePopup.querySelector('[data-ipta-booking-service-select]');
          if (select) setTimeout(function () { select.focus(); }, 150);
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
